
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/totango",
      function () {
        return require("private-next-pages/destinations/totango.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/totango"])
      });
    }
  